
import _, { cloneDeep } from 'lodash-es'

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    },
    sectionId: {
      type: String,
      default: ''
    },
    bind: {
      type: String,
      default: ''
    },
    rect: {
      type: Object,
      default: () => ({
        top: 0,
        left: 0,
        width: 100,
        height: 100
      })
    },
  },
  mounted() {

  },
  computed: {
    element() {
      // get html element from data-jr-section-id and data-jr-bind
      return this.sectionId && this.bind ? document.querySelector(`[data-jr-section-id="${this.sectionId}"] [data-jr-bind="${this.bind}"]`) : null;
    },
    scheme() {
      switch (this.type) {
        case 'text':
          const textScheme = [{
            type: "JrDesignerFormItemText",
            field: this.bind,
            value: this.value
          }];
          return textScheme;
        case 'image':
          const imageScheme = [{
            type: "JrDesignerFormItemImage",
            field: this.bind,
            value: this.value
          }];
          return imageScheme;
        case 'video':
          const videoScheme = [{
            type: "JrDesignerFormItemVideo",
            field: this.bind,
            value: this.value
          }];
          return videoScheme;
        case 'list':
          const schemeJSON = this.element && this.element.dataset && this.element.dataset.jrScheme;
          const scheme = schemeJSON ? JSON.parse(schemeJSON) : [];
          const mergedScheme = scheme.map(item => {
            if (item && item.type && item.type.startsWith('jr-')) {
              if (item.type === 'jr-image') {
                const imageScheme = {
                  type: "JrDesignerFormItemImage",
                  field: item.name,
                  title: item.label,
                }
                return imageScheme;
              } else if (item.type === 'jr-video') {
                const videoScheme = {
                  type: "JrDesignerFormItemVideo",
                  field: this.bind,
                  value: this.value
                };
                return videoScheme;
              } else if (item.type === 'jr-text') {
                const textScheme = {
                  type: "JrDesignerFormItemText",
                  field: item.name,
                  title: item.label
                };
                return textScheme;
              } else if (item.type === 'jr-list') {
                const listScheme = {
                  type: 'object',
                  field: item.name,
                  title: item.label,
                  props: {
                    rule: [{
                      type: 'div',
                      children: ['请选择子列表进行编辑']
                    }]
                  }
                }
                return listScheme;
              }
            } else {
              return item
            }
          });
          return mergedScheme;
        default:
          return [];
      }
    },
    parentList() {
      console.log(this.$el);
      
      if(this.element != null && this.type != null) {
        console.log(this.element.parentNode.closest('[data-jr-type="list"]'));
        const elm = this.element;
        const jrList = elm.parentNode.closest('[data-jr-type="list"]');
        return jrList;
      }
    },
    value() {
      const section = this.$store.getters['page/getSection'](this.sectionId);
      return _.get(section.data, this.bind)
    }
  },
  watch: {
    element() {
      if (this.type == 'text') {
        this.handleText();
      }
    }
  },
  methods: {
    async handleText() {
      const { default: tinymce } = await import('~/lib/tinymce');
      const vm = this;
      if (this.sectionId && this.bind && !tinymce.get(this.element.id)) {
        tinymce.init({
          target: this.element,
          plugins: ['quickbars'],
          toolbar: false,
          menubar: false,
          inline: true,
          setup: editor => {
            editor.on('Change', () => {
              const section = cloneDeep(vm.$store.getters['page/getSection'](vm.sectionId));
              _.set(section.data, vm.bind, { content: editor.getContent() });
              vm.$store.commit('page/setSection', { section });
            });
          }
        })
      }

    },
    async handleEditClick() {

      if (this.type == 'text') {
        // const { default: tinymce } = await import('~/lib/tinymce');
        // const activeEd = tinymce.get(this.element.id);
        // if (activeEd) {
        //   activeEd.focus();
        //   activeEd.selection.select(activeEd.getBody(), true);
        // }
        const currentText = this.$store.getters['page/getSection'](this.sectionId)[this.bind];
        this.$store.commit('editor/showEditFormDialog', {
          rule: this.scheme,
          onConfirm: (value) => {
            if (this.sectionId && this.bind) {
              const section = cloneDeep(this.$store.getters['page/getSection'](this.sectionId));
              _.set(section.data, this.bind, value[this.bind]);
              this.$store.commit('page/setSection', { section });
              this.$nextTick(() => {
                document.querySelectorAll('.swiper, .swiper-container').forEach(item => {
                  item.swiper && item.swiper.update && item.swiper.update(true);
                })
              })
            }
          }
        });
      } else if (this.type == 'image') {
        const currentImg = this.$store.getters['page/getSection'](this.sectionId)[this.bind];
        // this.$store.commit('editor/showFilePickerDialog', {
        //   url: currentImg?.src,
        //   onConfirm: (url) => {
        //     if (this.sectionId && this.bind) {
        //       const section = cloneDeep(this.$store.getters['page/getSection'](this.sectionId));
        //       _.set(section.data, this.bind, { src: url, pcSrc: url, mobileSrc: url });
        //       this.$store.commit('page/setSection', { section });
        //     }
        //   }
        // });
        this.$store.commit('editor/showEditFormDialog', {
          rule: this.scheme,
          onConfirm: (value) => {
            if (this.sectionId && this.bind) {
              const section = cloneDeep(this.$store.getters['page/getSection'](this.sectionId));
              _.set(section.data, this.bind, value[this.bind]);
              this.$store.commit('page/setSection', { section });
              this.$nextTick(() => {
                document.querySelectorAll('.swiper, .swiper-container').forEach(item => {
                  console.log(item);
                  item.swiper && item.swiper.update && item.swiper.update(true);
                })
              })
            }
          }
        });
      } else if (this.type == 'video') {
        // const currentVid = this.$store.getters['page/getSection'](this.sectionId)[this.bind];
        // this.$store.commit('editor/showFilePickerDialog', {
        //   url: currentVid?.src,
        //   onConfirm: (url) => {
        //     if (this.sectionId && this.bind) {
        //       const section = cloneDeep(this.$store.getters['page/getSection'](this.sectionId));
        //       _.set(section.data, this.bind, { ...currentVid, src: url });
        //       this.$store.commit('page/setSection', { section });
        //     }
        //   }
        // });
        this.$store.commit('editor/showEditFormDialog', {
          rule: this.scheme,
          onConfirm: (value) => {
            if (this.sectionId && this.bind) {
              const section = cloneDeep(this.$store.getters['page/getSection'](this.sectionId));
              _.set(section.data, this.bind, value[this.bind]);
              this.$store.commit('page/setSection', { section });
              this.$nextTick(() => {
                document.querySelectorAll('.swiper, .swiper-container').forEach(item => {
                  console.log(item);
                  item.swiper && item.swiper.update && item.swiper.update(true);
                })
              })
            }
          }
        });
      } else if (this.type == 'list') {
        this.$store.commit('editor/showEditFormDialog', {
          rule: [{
            type: 'object',
            field: this.bind,
            // title: '列表',
            value: this.value,
            props: {
              rule: [
                {
                  type: 'group',
                  field: 'items',
                  // title: '列表项',
                  props: {
                    rule: this.scheme ?? []
                  }
                }
              ]
            }
          }],
          onConfirm: (value) => {
            if (this.sectionId && this.bind) {
              const section = cloneDeep(this.$store.getters['page/getSection'](this.sectionId));
              _.set(section.data, this.bind, value[this.bind]);
              this.$store.commit('page/setSection', { section });
            }
          }
        });
      }
    },
    handleParentListClick() {

    }
  }
}
